import { Navigate } from 'react-router-dom'
import { NoPermissionPage } from '../pages'

const ProtectedRoute = ({
    isAllowed,
    children,
    redirectTo = null
}) => {
    if (!isAllowed) {
        if (redirectTo) {
            return <Navigate to={redirectTo} replace />
        }
        return <NoPermissionPage />
    }
    return children
}

export default ProtectedRoute
